import { ActionButtonEnum } from "../enums/actionButtonEnum";

function useActionButtons(actions: ActionButtonEnum[]) {
  const hasActions = actions.length > 0;

  const isToShowRefreshAction =
    hasActions && actions.includes(ActionButtonEnum.REFRESH);

  const isToShowSavePDFAction =
    hasActions && actions.includes(ActionButtonEnum.SAVE_PDF);

  const isToShowSaveCSVAction =
    hasActions && actions.includes(ActionButtonEnum.SAVE_CSV);

  return {
    isToShowRefreshAction,
    isToShowSavePDFAction,
    isToShowSaveCSVAction,
  };
}

export default useActionButtons;
